<script setup>
import LazyContent from '../UI/Loading/LazyContent.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import MediaList from '../UI/Media/MediaList.vue'
import MediaListItem from '../UI/Media/MediaListItem.vue'

defineProps({
  sections: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const getIconClass = (icon) => {
  if (!!icon) {
    return `fas fa-${icon}`
  }
  return null
}

const getBootstrapTextClass = (style) => {
  if (!!style) {
    return `text-${style}`
  }
  return null
}
</script>

<template>
  <LazyContent :loading="loading">
    <BlockContent
      v-for="(section, index) in sections"
      :key="index"
      :title="section.title"
      title-level="5"
      :color="section?.style?.color"
      :icon="getIconClass(section?.style?.icon)"
      :e2e-block="'homeDashboardContent-' + index"
    >
      <MediaList>
        <MediaListItem
          v-for="(item, itemIndex) in section.items"
          :key="itemIndex"
          :href="item.url"
          target="_blank"
          :doc-preview-url="item.itemType === 'document' ? item.url : null"
        >
          <span :class="getBootstrapTextClass(item?.style?.color)">
            <i v-if="!!item?.style?.icon" :class="getIconClass(item.style.icon)" class="mr-1"></i>
            {{ item.title }}
          </span>
        </MediaListItem>
      </MediaList>
    </BlockContent>
  </LazyContent>
</template>
